import { render, staticRenderFns } from "./PatientIdentification.vue?vue&type=template&id=f94473f6&scoped=true"
import script from "./PatientIdentification.vue?vue&type=script&lang=js"
export * from "./PatientIdentification.vue?vue&type=script&lang=js"
import style0 from "./PatientIdentification.vue?vue&type=style&index=0&id=f94473f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94473f6",
  null
  
)

export default component.exports